import Head from 'next/head';
import { Link } from '../../core/helpers/link';

type Props = {
  links: Link[];
};

const LinkTag = ({ links }: Props) => {
  return (
    <Head>
      {(links ?? []).map((link) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <link key={link?.key || link?.href} {...link} />
      ))}
    </Head>
  );
};

export default LinkTag;
